export const SYONET_SCHEDULE_OPTIONS = [
    { id: '*/15 * * * *', name: 'A cada 15 minutos' },
    { id: '*/30 * * * *', name: 'A cada 30 minutos' },
    { id: '0 * * * *', name: 'A cada 1 hora' },
    { id: '0 */2 * * *', name: 'A cada 2 horas' },
    { id: '0 0 * * *', name: 'Todos os dias às 00:00' },
    { id: '0 1 * * *', name: 'Todos os dias às 01:00' },
    { id: '0 2 * * *', name: 'Todos os dias às 02:00' },
    { id: '0 3 * * *', name: 'Todos os dias às 03:00' },
    { id: '0 4 * * *', name: 'Todos os dias às 04:00' },
    { id: '0 5 * * *', name: 'Todos os dias às 05:00' },
];

export const getScheduleLabel = ruleCron => {
    return (
        SYONET_SCHEDULE_OPTIONS.find(option => option.id === ruleCron)?.name ||
        ruleCron
    );
};
